import { Controller } from "@hotwired/stimulus"

// Sends the browser to `url` after `delay` ms. When the page has a `counter`
// target it counts the seconds down in it, so the customer sees when they
// will be taken back.
export default class extends Controller {
  static targets = ["counter"]
  static values = { url: String, delay: { type: Number, default: 2000 } }

  connect() {
    this.deadline = Date.now() + this.delayValue
    this.timer = setTimeout(() => {
      window.location.href = this.urlValue
    }, this.delayValue)

    if (this.hasCounterTarget) {
      this.tick()
      this.ticker = setInterval(() => this.tick(), 250)
    }
  }

  disconnect() {
    clearTimeout(this.timer)
    clearInterval(this.ticker)
  }

  tick() {
    const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000))

    this.counterTargets.forEach((counter) => { counter.textContent = seconds })
  }
}
